/**
 * Created by zad on 17/1/12.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Animate from 'rc-animate';
import Loader from './Loader';
import styles from './Loading.scss';

const loadingPrefix = 'loading';

export default class Loading extends Component {
  static propTypes = {
    size: PropTypes.oneOf(['small', 'default', 'large']),
    loading: PropTypes.bool,
    tip: PropTypes.string,
    delay: PropTypes.number,
    hasMask: PropTypes.bool,
    wrapperClassName: PropTypes.string,
    loaderClassName: PropTypes.string,
  };

  static defaultProps = {
    loading: true,
    delay: undefined,
    hasMask: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: this.props.loading,
    };
    this.debounceLoading = this.debounceLoading.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.debounceLoading(nextProps);
  }

  componentWillUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  // 对改变loading状态进行去抖
  debounceLoading(nextProps) {
    const prevLoading = this.props.loading;
    const nextLoading = nextProps.loading;
    const { delay } = this.props;

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    // 如果设定了delay且前后状态不一致
    if (delay && !Number.isNaN(+delay) && prevLoading !== nextLoading) {
      this.debounceTimer = setTimeout(() => this.setState({ loading: nextLoading }), delay);
    } else {
      this.setState({ loading: nextLoading });
    }
  }

  getLoader = () => {
    const { loading } = this.state;
    const { size, tip, hasMask, loaderClassName } = this.props;
    if (loading) {
      return (
        <Loader
          loaderClassName={loaderClassName}
          hasMask={hasMask}
          size={size}
          tip={tip}
          loading={loading}
          key={'loader'}
        />
      );
    }
    return null;
  };

  render() {
    const { size, tip, hasMask, wrapperClassName, loaderClassName, children } = this.props;
    const { loading } = this.state;
    const transition = hasMask ? undefined : 'fade';

    if (children) {
      const wrapperClass = classNames(wrapperClassName, {
        [`${styles[`${loadingPrefix}-has-children`]}`]: true,
      });
      const containerClass = classNames({
        [`${styles[`${loadingPrefix}-container`]}`]: true,
        [`${styles[`${loadingPrefix}-blur`]}`]: loading,
      });

      return (
        <Animate
          className={wrapperClass}
          transitionName={transition}
          component="div"
        >
          {this.getLoader()}
          <div key="container" className={containerClass}>
            {children}
          </div>
        </Animate>
      );
    }

    return (
      <Loader size={size} tip={tip} loading={loading} loaderClassName={loaderClassName}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js